export const useStopScroll = () => {
  const stopBodyScroll = (isOpen: boolean) => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  return { stopBodyScroll };
};
